import React, { useState, useEffect } from 'react';
import './index.css';
import Login from './components/Login';
import TicketList from './components/TicketList';
import azureDevOpsService from './services/azureDevOps';
import authService from './services/authService';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const initializeAuth = async () => {
            try {
                console.log('Starting auth initialization...');
                setLoading(true);
                const isAuthed = await authService.initialize();
                console.log('Auth initialized, isAuthed:', isAuthed);
                setIsAuthenticated(isAuthed);
            } catch (error) {
                console.error('Auth initialization error:', error);
                setIsAuthenticated(false);
            } finally {
                console.log('Completing initialization, setting loading to false');
                setLoading(false);
            }
        };

        initializeAuth();
    }, []);

    // Add logging to track render conditions
    console.log('App render - loading:', loading, 'isAuthenticated:', isAuthenticated);

    if (loading) {
        return (
            <div className="min-h-screen bg-gray-100 flex items-center justify-center">
                <div className="text-gray-600">Loading...</div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Login onLoginSuccess={() => setIsAuthenticated(true)} />;
    }

    const userAccount = authService.getAccount();
    console.log('Rendering main app with user account:', userAccount);

    return (
        <div className="min-h-screen bg-gray-100 p-4">
            <div className="max-w-6xl mx-auto">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-bold text-gray-800">
                        Work Items
                    </h1>
                    <div className="flex items-center space-x-4">
                        {userAccount && (
                            <span className="text-sm text-gray-600">
                                {userAccount.username}
                            </span>
                        )}
                        <button
                            onClick={() => {
                                console.log('Logout clicked');
                                authService.logout();
                                setIsAuthenticated(false);
                            }}
                            className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                        >
                            Sign Out
                        </button>
                    </div>
                </div>

                <TicketList
                    key={userAccount?.username} // Force remount on user change
                    azureService={azureDevOpsService}
                />
            </div>
        </div>
    );
}

export default App;